/**
 * Tooltip cleanup utilities
 * Prevents tooltip divs from accumulating and causing layout issues
 */

import React from 'react';
import * as d3 from 'd3';

/**
 * Remove all D3 tooltips from the DOM
 */
export const cleanupTooltips = () => {
  // Remove all tooltip elements
  d3.selectAll('.tooltip').remove();
  d3.selectAll('.d3-tooltip').remove();
  d3.selectAll('.d3-treemap-tooltip').remove();
  d3.selectAll('.globe-tooltip').remove();
  
  // Also remove any tooltip elements that might have been created with different classes
  const tooltipElements = document.querySelectorAll('[class*="tooltip"]');
  tooltipElements.forEach(element => element.remove());
};

/**
 * Hook to cleanup tooltips when component unmounts
 */
export const useTooltipCleanup = () => {
  React.useEffect(() => {
    return () => {
      cleanupTooltips();
    };
  }, []);
};

/**
 * Cleanup tooltips on page navigation
 */
export const cleanupTooltipsOnNavigation = () => {
  // Clean up on page load
  cleanupTooltips();
  
  // Clean up when page is about to unload
  window.addEventListener('beforeunload', cleanupTooltips);
  
  // Clean up when page visibility changes (e.g., switching tabs)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      cleanupTooltips();
    }
  });
};

export default cleanupTooltips;
